import { render, staticRenderFns } from "./MenuRow.vue?vue&type=template&id=632f7292&"
import script from "./MenuRow.vue?vue&type=script&lang=ts&"
export * from "./MenuRow.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports